import { render, staticRenderFns } from "./DetailIndex.vue?vue&type=template&id=b233ba70&scoped=true&"
import script from "./DetailIndex.vue?vue&type=script&lang=js&"
export * from "./DetailIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b233ba70",
  null
  
)

export default component.exports